import axios from 'axios'

export default {
	namespaced: true,
	state: {
		infoUsuario: {
			ID: null,
			nombre: null,
			apellidos: null,
			avatar: null,
			tipo: null
		},
		activa: null,
		externo: null,
		requiere2fa: null,
		direccionIP: null,
		cambioPass: false,
		bloqueado: false,
		afterLoginPath: null
	},
	getters: {
		usuario (state) {
			return state.infoUsuario
		},
		ip (state) {
			return state.direccionIP
		},
		haySesion (state) {
			return state.activa
		},
		cambiarPass (state) {
			return state.cambioPass
		},
		externo (state) {
			return state.externo
		},
		requiere2fa (state) {
			return state.requiere2fa
		},
		sesionBloqueada (state) {
			return state.bloqueado
		},
		afterLoginPath (state) {
			return state.afterLoginPath
		}
	},
	mutations: {
		setUsuario (state, payload) {
			state.infoUsuario = {
				ID: payload.usuario.ID,
				nombre: payload.usuario.nombre,
				apellidos: payload.usuario.apellidos,
				avatar: payload.usuario.avatar,
				tipo: payload.usuario.tipo
			}

			state.activa = true
			state.externo = payload.externo
			state.requiere2fa = payload.requiere2fa
			state.direccionIP = payload.ip
		},
		setCambioPass (state, payload) {
			state.cambioPass = payload
		},
		setBloqueado (state, payload) {
			state.bloqueado = payload
		},
		setActiva (state, payload) {
			state.activa = payload
		},
		sesionFuera (state, {externo, requiere2fa}) {
			state.infoUsuario = {
				ID: null,
				nombre: null,
				apellidos: null,
				avatar: null,
				tipo: null
			}

			state.activa = false
			state.bloqueado = false
			state.externo = externo
			state.requiere2fa = requiere2fa
		},
		SET_AFTER_LOGIN (state, path) {
			state.afterLoginPath = path
		}
	},
	actions: {
		login (context, payload) {
			const datos = {
				usuario: payload.usuario,
				password: payload.password,
				token: payload.token,
				recordarme: payload.recordarme
			}

			axios.post('core/php/api/sesion/login.php', datos)
				.then(res => {
					if (res) {
						if (res.data && res.data.cambiarpass) {
							context.commit('setCambioPass', true)
						} else {
							context.commit('setCambioPass', false)
							context.commit('setUsuario', res.data)
						}
					}
				})
				.catch(e => {
					this.commit('alertas/alert', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
					context.commit('sesionFuera')
				})
		},
		logout (context) {
			axios.post('core/php/api/sesion/logout.php')
				.then(res => {
					context.commit('SET_AFTER_LOGIN', null)
					context.commit('sesionFuera')
				})
				.catch(e => {
					console.log(e)
					console.error('Error cerrando sesión')
					context.commit('sesionFuera')
				})
		},
		getSesion (context) {
			axios.get('core/php/api/sesion/get.php')
				.then(res => {
					if (res.data && res.data.cambiarpass) {
						context.commit('setCambioPass', true)
						context.commit('setActiva', true)
						return
					} else if (res.data && res.data.inactivo) {
						context.commit('setBloqueado', res.data.usuario)
						context.commit('setActiva', true)
						return
					}
					context.commit('setBloqueado', false)
					context.commit('setCambioPass', false)
					context.commit('setUsuario', res.data)
				})
				.catch(e => {
					if (e.response) {
						context.commit('sesionFuera', {externo: e.response.data.externo, requiere2fa: e.response.data.requiere2fa})
					}
				})
		},
		lock (context, payload) {
			axios.get('core/php/api/sesion/bloquear.php')
				.then(res => {
					// recibimos el usuario
					context.commit('setBloqueado', res.data.usuario)
				})
				.catch(e => {
					this.commit('alertas/error', {
						titulo: 'Error',
						mensaje: 'Contraseña incorrecta'
					})
				})
		},
		doDesbloquear (context, payload) {
			const datos = {
				password: payload
			}
			axios.post('core/php/api/sesion/desbloquear.php', datos)
				.then(res => {
					// recibimos el usuario
					context.commit('setBloqueado', false)
					context.commit('setActiva', true)
					context.commit('setUsuario', res.data)
				})
				.catch(e => {
					this.commit('alertas/error', {
						titulo: 'Error',
						mensaje: 'Contraseña incorrecta'
					})
				})
		}
	}
}



// WEBPACK FOOTER //
// ./src/modulos/core/vue/store/session.js